// extracted by mini-css-extract-plugin
export var modalFooter = "_ko-0";